<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header" :class="{ 'no-button': !selectedType }">
      <h1 :class="{ 'full-width': !selectedType }">{{ $t("Barème CEE") }}</h1>
      <b-button v-if="selectedType" variant="danger" @click="goBack" class="button-succes-style">
        <font-awesome-icon icon="arrow-left" /> {{ $t("Retour") }}
      </b-button>
    </div>
    
    <div class="content" v-if="!selectedType">
      <div class="row">
        <div class="col-12 mb-2" v-for="type in entityTypes" :key="type.value">
          <div class="card entity-card w-100" @click="selectType(type.value)">
            <div class="card-body text-center">
              <div class="card-icon">
                <font-awesome-icon :icon="type.icon" size="3x" />
              </div>
              <h5 class="card-title mt-2 mb-2">{{ type.label }}</h5>
              <p class="card-text mb-0">{{ type.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content" v-if="selectedType">
      <div class="content-header">
        <div class="d-flex align-items-center">
          <h3 class="mb-0 mr-3">{{ getSelectedTypeLabel() }}</h3>
        </div>
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="searchFilter"
            :placeholder="$t('Rechercher...')"
            class="mr-2"
            style="width: 250px;"
          />
          <font-awesome-icon icon="search" class="text-muted" />
        </div>
      </div>

      <div class="filtre">
        <p class="table-count">
          {{ getTotalRowEntiteExterne }} {{ $t("entités") }}
        </p>
      </div>

      <div class="table-rapport-style w-100">
        <div v-if="getLoadingEntiteExterne" class="text-center p-4">
          <b-spinner variant="primary" label="Chargement..."></b-spinner>
          <p class="mt-2">{{ $t("Chargement des entités...") }}</p>
        </div>
        <table v-else>
          <thead>
            <tr>
              <th style="border-radius: 5px 0px 0px 0px">{{ $t("Nom") }}</th>
              <th>{{ $t("SIRET") }}</th>
              <th style="border-radius: 0px 5px 0px 0px" class="action_head">{{ $t("Actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entity in filteredEntities" :key="entity.id" role="row" class="ligneNormale">
              <td aria-colindex="1" role="cell">{{ entity.nom }}</td>
              <td aria-colindex="2" role="cell">{{ entity.siret }}</td>
              <td aria-colindex="3" role="cell" class="action_col">
                <b-button 
                  class="button-succes-style"
                  size="sm" 
                  variant="primary"
                  @click="openSettingsModal(entity)"
                >
                  <font-awesome-icon icon="cog" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <b-pagination
        v-if="selectedType"
        v-model="page"
        :total-rows="getTotalRowEntiteExterne"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class="mt-3"
      ></b-pagination>
    </div>

    <!-- Modal Settings -->
    <!-- <b-modal 
      v-model="showSettingsModal" 
      :title="$t('Paramètres') + ' - ' + (selectedEntity?.nom || '')"
      size="lg"
    >
      <div v-if="selectedEntity">
        <div class="row">
          <div class="col-md-6">
            <b-form-group :label="$t('Prix CEE')">
              <b-form-input 
                v-model="selectedEntity.prixCEE" 
                type="number" 
                step="0.01"
              />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('Prix Annah')">
              <b-form-input 
                v-model="selectedEntity.prixAnnah" 
                type="number" 
                step="0.01"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group :label="$t('Termes CEE')">
              <b-form-textarea 
                v-model="selectedEntity.paragraphCEE" 
                rows="4"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group :label="$t('Termes MaPrimeRénov')">
              <b-form-textarea 
                v-model="selectedEntity.paragraphMaPrimeRenov" 
                rows="4"
              />
            </b-form-group>
          </div>
        </div>
      </div>
      
      <template #modal-footer>
        <b-button variant="secondary" @click="showSettingsModal = false">
          {{ $t("Annuler") }}
        </b-button>
        <b-button variant="success" @click="saveSettings">
          {{ $t("Sauvegarder") }}
        </b-button>
      </template>
    </b-modal> -->

    <!-- Modal Add -->
    <!-- <mandataireEtpartenairemodale
      v-if="showAddModal"
      :isOpen="showAddModal"
      @close="closeAddModal"
      @confirm="handleAdd"
    /> -->

    <!-- Modal Delete Confirmation -->
    <!-- <b-modal 
      v-model="showDeleteModal" 
      :title="$t('Confirmer la suppression')"
    >
      <p>{{ $t("Êtes-vous sûr de vouloir supprimer") }} <strong>{{ entityToDelete?.nom }}</strong> ?</p>
      
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">
          {{ $t("Annuler") }}
        </b-button>
        <b-button variant="danger" @click="deleteEntity">
          {{ $t("Supprimer") }}
        </b-button>
      </template>
    </b-modal> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import mandataireEtpartenairemodale from "@/components/Ajoutmodel/mandataireEtpartenairemodale.vue";

export default {
  components: {
    // mandataireEtpartenairemodale
  },
  data() {
    return {
      selectedType: null,
      searchFilter: "",
      showSettingsModal: false,
      showAddModal: false,
      showDeleteModal: false,
      selectedEntity: null,
      entityToDelete: null,
      page: 1,
      perPage: 10,
      entityTypes: [
        {
          value: "delegataire",
          label: "Délégateur",
          description: "Gestion des délégateurs CEE",
          icon: "building"
        },
        {
          value: "mandataire", 
          label: "Mandataire",
          description: "Gestion des mandataires CEE",
          icon: "user-tie"
        },
        {
          value: "oblige",
          label: "Obligé",
          description: "Gestion des obligés CEE", 
          icon: "certificate"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getAllEntitesExternes", "getTabs", "getLoadingEntiteExterne", "getOnlineUser", "getTotalRowEntiteExterne"]),
    isSuperAdmin() {
      return this.getOnlineUser?.role === "user.super-admin";
    },
    filteredEntities() {
      if (!this.selectedType) return [];
      // Les entités sont déjà filtrées côté serveur par type et paginées
      let entities = this.getAllEntitesExternes || [];
      
      // Filtrer par recherche si nécessaire (filtrage côté client pour la recherche)
      if (this.searchFilter) {
        const filter = this.searchFilter.toLowerCase();
        entities = entities.filter(entity => 
          entity.nom?.toLowerCase().includes(filter) ||
          entity.siret?.toLowerCase().includes(filter)
        );
      }
      
      return entities;
    }
  },
  methods: {
    ...mapActions(["allEntitesExternes", "editEntiteExterne", "deleteEntiteExterne"]),
    
    selectType(type) {
      this.selectedType = type;
      this.page = 1; // Réinitialiser à la page 1 lors du changement de type
      this.loadEntities();
    },
    
    goBack() {
      this.selectedType = null;
      this.page = 1;
    },
    
    getSelectedTypeLabel() {
      const type = this.entityTypes.find(t => t.value === this.selectedType);
      return type ? type.label : "";
    },
    
    async loadEntities() {
      const params = {
        type: this.selectedType,
        page: this.page,
        per_page: this.perPage
      };
      
      // Ajouter entreprise_id si l'utilisateur n'est pas super admin
      if (!this.isSuperAdmin && this.getOnlineUser?.entreprise?.id) {
        params.entreprise_id = this.getOnlineUser.entreprise.id;
      }
      
      await this.allEntitesExternes(params);
    },
    
    pagination(page) {
      this.page = page;
      this.loadEntities();
    },
    
    openSettingsModal(entity) {
      this.$router.push({
        path: '/configuration',
        query: { entityId: entity.id }
      });
    },
    
    async saveSettings() {
      try {
        await this.editEntiteExterne(this.selectedEntity);
        this.showSettingsModal = false;
        this.loadEntities();
      } catch (error) {
        console.error("Erreur lors de la sauvegarde:", error);
      }
    },
    
    openAddModal() {
      this.showAddModal = true;
    },
    
    closeAddModal() {
      this.showAddModal = false;
    },
    
    async handleAdd(entityData) {
      entityData.type = this.selectedType;
      this.closeAddModal();
      this.loadEntities();
    },
    
    confirmDelete(entity) {
      this.entityToDelete = entity;
      this.showDeleteModal = true;
    },
    
    async deleteEntity() {
      try {
        await this.deleteEntiteExterne(this.entityToDelete);
        this.showDeleteModal = false;
        this.loadEntities();
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
      }
    }
  },
  
  mounted() {
    // Charger toutes les entités au démarrage si nécessaire
  }
};
</script>

<style scoped>
.entity-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 150px;
  border: 2px solid #24316d;
  border-radius: 5px;
  margin-bottom: 0.5rem;
}

.entity-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  border-color: #24316d;
}

.entity-card:hover .card-icon {
  transform: scale(1.1);
  transition: transform 0.2s;
}

.card-body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.card-icon {
  color: #24316d;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-title {
  color: #24316d;
  font-weight: bold;
  font-size: 1rem;
}

.card-text {
  font-size: 0.875rem;
  color: #666;
}

.page-header.no-button h1.full-width {
  width: 100% !important;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.content-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #393939;
}

.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}
</style>